<template>
	<div
		class="g-block-qrcode-nav-banner"
		:class="{
			'g-block-qrcode-nav-banner--edit': editable,
			'is-active': editable && active,
			'g-block-qrcode-nav-banner--h5': h5,
		}"
		:style="bannerStyle"
		@click="onWrapClick"
	>
		<div class="g-block-qrcode-nav-banner__main">
			<div class="g-block-qrcode-nav-banner__title">{{ title }}</div>
			<div class="g-block-qrcode-nav-banner__desc">{{ description }}</div>
		</div>
		<div class="g-block-qrcode-nav-banner__arrow" aria-hidden="true">
			<i class="mbm-iconfont mbm-youjiantou"></i>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import {
		getQrcodeNavBannerStyle,
		normalizeQrcodeNavData,
		QRCODE_NAV_TYPES,
	} from '../../../utils/qrcodeNav.js';

	export default {
		name: 'GQrcodeNavBannerShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			normalizedData() {
				return normalizeQrcodeNavData(QRCODE_NAV_TYPES.banner, this.data);
			},
			title() {
				return this.normalizedData.title;
			},
			description() {
				return this.normalizedData.description;
			},
			bannerStyle() {
				return getQrcodeNavBannerStyle(QRCODE_NAV_TYPES.banner, this.data, { h5: this.h5 });
			},
		},
		methods: {
			onWrapClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && this.normalizedData.jumpLink?.type) {
					e?.stopPropagation?.();
					navigateJumpLink(this.normalizedData.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-qrcode-nav-banner {
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 88px;
		padding: 16px 18px;
		box-sizing: border-box;
		cursor: default;

		&--edit {
			border: 1px solid transparent;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {
			gap: 0.24rem;
			min-height: 1.76rem;
			padding: 0.32rem 0.36rem;
		}
	}

	.g-block-qrcode-nav-banner__main {
		flex: 1;
		min-width: 0;
	}

	.g-block-qrcode-nav-banner__title {
		font-size: 17px;
		font-weight: 600;
		line-height: 1.4;
		margin-bottom: 6px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-qrcode-nav-banner--h5 & {
			font-size: 0.34rem;
			margin-bottom: 0.12rem;
		}
	}

	.g-block-qrcode-nav-banner__desc {
		font-size: 12px;
		line-height: 1.6;
		opacity: 0.92;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;

		.g-block-qrcode-nav-banner--h5 & {
			font-size: 0.24rem;
		}
	}

	.g-block-qrcode-nav-banner__arrow {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		border: 1px solid currentColor;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0.95;

		i {
			font-size: 12px;
			line-height: 1;
		}

		.g-block-qrcode-nav-banner--h5 & {
			width: 0.64rem;
			height: 0.64rem;

			i {
				font-size: 0.24rem;
			}
		}
	}
</style>
